import * as React from 'react';

import { cn } from '@/libs/cn.ts';

import { CheckGroupItem } from './check-group-item/check-group-item.tsx';

import './check-group.css';

type Choice = {
  key: string;
  value: string;
  status: 'checked' | 'unchecked' | 'indeterminate';
  disabled: boolean;
};

interface CheckGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  choices: Array<Choice>;
  group: string;
  size?: 'small' | 'medium' | 'large';
  orientation?: 'row' | 'column';
  onOptionChange?: (c: Choice) => void;
  error?: boolean;
}

const CheckGroup = React.forwardRef<HTMLDivElement, CheckGroupProps>(
  (
    {
      choices,
      group,
      size = 'small',
      orientation = 'column',
      onOptionChange,
      error,
      ...props
    },
    ref,
  ) => {
    const checkGroupItemChangeHandler =
      (c: Choice): React.ChangeEventHandler<HTMLInputElement> =>
      () => {
        onOptionChange?.(c);
      };

    return (
      <div
        className={cn(`check-group check-group-${orientation}-${size}`, {
          'check-group--error': error,
        })}
        ref={ref}
        {...props}
      >
        {choices.map(choice => {
          return (
            <CheckGroupItem
              key={choice.key}
              id={choice.key}
              label={choice.value}
              value={choice.value}
              disabled={choice.disabled}
              checked={['checked', 'indeterminate'].includes(choice.status)}
              indeterminate={choice.status === 'indeterminate'}
              scale={size}
              group={group}
              onChange={checkGroupItemChangeHandler(choice)}
            />
          );
        })}
      </div>
    );
  },
);

export { CheckGroup };
